module.exports = {
  'entityName': 'request',
  'pagination': {
    'rowsPerPage': 10,
    'page': 1,
    'sortBy': 'id',
    'descending': true
  },
  'fields': [
    {
      'value': 'request_date',
      'text': 'Request date',
      'type': 'datetime',
      validators: ['required']
    },
    {
      'value': 'provider_id',
      'id': 'provider_id',
      'reference': 'drug',
      'text': 'Provider',
      'type': 'autocomplete',
      'filter': item => ({ protocol_id: item.protocol_id, always_available: 0 }),
      'title': 'provider.name',
      'subtitle': 'provider.country',
      validators: ['required']
    },
    {
      value: 'first_request',
      type: 'check',
      text: 'First request'
    }
  ],
  'actions': [
    'upsert'
  ]
}
